import React, { useState, useEffect } from 'react';

const ViewInsightsUIList = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    const iframe = document.querySelector('iframe');
    if (iframe) {
      iframe.onload = () => {
        try {
          // This line will throw an error if we can't access the content
          const iframeContent = iframe.contentWindow.document.body;
          if (!iframeContent || iframeContent.innerHTML === '') {
            setError('Failed to load insights. Please check your connection and permissions.');
          }
        } catch (e) {
          // If we can't access the content, assume it loaded successfully
          setError(null);
        }
      };

      iframe.onerror = () => {
        setError('Failed to load insights. Please check your connection and try again.');
      };
    }

    return () => {
      if (iframe) {
        iframe.onload = null;
        iframe.onerror = null;
      }
    };
  }, []);

  return (
    <>
      {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
      <iframe 
        src='https://insights-ui.symbl.ai/?o=65a65d2129f003b18e0fea2121f53740c17c120bc0e0fa88a3d1d9395f8ce78b985a888073eb43192512b6d6c39abd37994130ed8a1e5e5b0654bf6babe85a5abadfc303a1c5223c2ff3e14e2ba51c9cbdc3999196127d0d67d3551894dca824a36b58415e391b1f9d5380fad8b4755cdcdbdacb11a3aaa60c3487464c328711d35a41291669fdc83ab1b125f73ed9b9bddf249ba065be6b471e508445314d4b6c33cefe77fae2e29b0e2dba016bd35e1cc1647c7de665bac556a7a79b3cc0d5feaa6cb3ba47a0c19953956ade3db06ce6e103237dc593578e18cc7982205c9990203839bf28cf961251b6770e5900df6e7fef49e8367fa2c9316d72c2405c3a3f2aec67e6de0499490fccf0&includeCallScore=false'
        style={{border: 0, width: "100%", height: "1000px"}}
      />
    </>
  );
};

export default ViewInsightsUIList;